import { ToggleState } from '@dgx-pr-spa/shared/util';
import { Specification } from '@dgx-pr-spa/shared/util';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-expandable-spec-table',
  templateUrl: './expandable-spec-table.component.html',
  styleUrls: ['./expandable-spec-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableSpecTableComponent implements OnChanges {
  defaultRows = 5;

  /**
   * Recieves array of specifications for the offer
   */
  @Input() specifications: Specification[] = [];

  /**
   * Recieves array of key features for the offer
   */
  @Input() keyFeatures: Specification[] = [];

  /**
   * Receives number of rows to show by default
   */
  @Input() visibleRows = this.defaultRows;

  /**
   * Tracks open state of accordion
   */
  isOpen = false;

  numberOfFeatures = 0;

  /**
   * Reset state on changes
   */
  ngOnChanges() {
    this.visibleRows = this.defaultRows;
    this.isOpen = false;
    this.numberOfFeatures = this.featureCount();
  }

  /**
   * Tracks visibility state of accordion
   */
  toggleClick(state: ToggleState) {
    this.isOpen = !this.isOpen;
    this.visibleRows =
      state === ToggleState.open
        ? this.specifications.length
        : this.defaultRows;

    if (!this.isOpen) {
      setTimeout(() => {
        const ele = document.getElementById('specHeader') as HTMLElement;
        if (typeof ele.scrollIntoView === 'function') {
          ele.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }, 0);
    }
  }

  featureCount() {
    return this.keyFeatures.filter((f) => f.value !== null)?.length;
  }
}
